module.exports = __webpack_public_path__ + "static/img/ld-footer-logo.212bd35.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/footer/ld-footer-logo.png
// module id = kdQQ
// module chunks = 0